/* eslint-disable */
// Generated with wikiLoadoutData.js.
export default {
  "schemaVersion": 2,
  "generatedAt": "2026-07-28",
  "liveVersion": "10.0.3",
  "characters": 94,
  "perks": 324,
  "items": 35,
  "addons": 909,
  "offerings": 107,
  "total": 1469
}
